import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SecuenciaPage } from './pages/SecuenciaPage';
render(<BrowserRouter data-id="element-171">
    <Routes data-id="element-172">
      <Route path="/" element={<App data-id="element-174" />} data-id="element-173" />
      <Route path="/secuencia" element={<SecuenciaPage data-id="element-176" />} data-id="element-175" />
    </Routes>
  </BrowserRouter>, document.getElementById('root'));